import { Error } from '../Field/Field.styled'
import * as S from './Checkbox.styled'

const Checkbox = ({ showErrorMsg, ...props }) => {
  return (
    <S.CheckboxWrap>
      <S.Checkbox error={props.error}>
        <input type='checkbox' {...props} />
        <S.CheckboxLabel>{props.label}</S.CheckboxLabel>
      </S.Checkbox>
      {showErrorMsg && props.error && <Error>{props.error}</Error>}
    </S.CheckboxWrap>
  )
}

export default Checkbox
